import { useQuery, gql } from '@apollo/client';
import { useSelector } from 'react-redux';

export function useReportDailyResponseAmperageLog() {
  const {
    electric: {
      power: {
        historicDailyLog: { year, week, day, dataPoint },
      },
    },
  } = useSelector(({ state }) => state);
  const { data = { reportDailyResponseAmperageLog: [] }, loading } = useQuery(GET_OVERVIEW, {
    variables: { year, week, day, dataPoint },
    skip: skip({ year, week, day, dataPoint }),
  });
  let dataOverview = [];
  data.reportDailyResponseAmperageLog.forEach((rows) => {
    dataOverview.push(rows);
  });
  return { loading, data: dataOverview || [] };
}

function skip(variables) {
  let skip = true;
  let { year, week, day, dataPoint } = variables;
  skip = ![year, week, day, dataPoint].every((v) => v);
  return skip;
}

const GET_OVERVIEW = gql`
  query ReportDailyResponseAmperageLog($year: Int!, $week: Int!, $day: Int!, $dataPoint: String!) {
    reportDailyResponseAmperageLog: ReportDailyResponseAmperageLog(
      year: $year
      week: $week
      day: $day
      dataPoint: $dataPoint
    ) {
      _id
      text
      color
      data {
        _id
        hour
        value
      }
    }
  }
`;
